import Grid from '@mui/material/Grid2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CtaButton from '../../components/CtaButton/CtaButton';
import FactoryIcon from '@mui/icons-material/Factory';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const BENEFITS = [
  "Reducción de errores en reportes",
  "Trazabilidad completa del material",
  "Certificados válidos y auditables",
];



function ProducersSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto py-96 px-40">
        <Grid container spacing={6} alignItems="center">

          <Grid size={{ xs: 12, md: 7 }}>
            <div className="inline-flex items-center gap-8 bg-[#EFF6FF] text-[#1A56DB] font-bold text-14 tracking-[0.06em] uppercase py-6 px-16 rounded-full mb-24">
              <FactoryIcon className="!text-18" />
              Productores
            </div>

            <h2 className="text-40 font-extrabold text-[#1E3A8A] leading-[1.2] mb-32">
              Cumplimiento REP sin fricciones
            </h2>

            <div className="flex items-stretch gap-0 mb-40">
              <div className="flex-1 rounded-16 py-28 px-24 flex flex-col gap-12 bg-[#FEF2F2] border-[1.5px] border-[#FECACA]">
                <div className="flex items-center gap-8">
                  <WarningAmberIcon className="!text-20 text-[#EF4444]" />
                  <span className="text-14 font-extrabold uppercase tracking-[0.08em] text-[#EF4444]">
                    El problema
                  </span>
                </div>
                <p className="text-16 leading-[1.7] m-0 text-[#374151]">
                  Cumplir con la REP implica consolidar información, validar certificados y reducir riesgos regulatorios.
                </p>
              </div>

              <div className="flex items-center justify-center px-10 shrink-0 text-[#94A3B8]">
                <ArrowForwardIcon className="!text-24" />
              </div>

              <div className="flex-1 rounded-16 py-28 px-24 flex flex-col gap-12 bg-[#EFF6FF] border-[1.5px] border-[#BFDBFE]">
                <div className="flex items-center gap-8">
                  <LightbulbIcon className="!text-20 text-[#1A56DB]" />
                  <span className="text-14 font-extrabold uppercase tracking-[0.08em] text-[#1A56DB]">
                    La solución
                  </span>
                </div>
                <p className="text-16 leading-[1.7] m-0 text-[#374151]">
                  EcoRep centraliza y automatiza tu gestión, permitiéndote reportar con información confiable y validada.
                </p>
              </div>
            </div>

            <p className="text-14 font-bold text-[#1E3A8A] mb-16 uppercase tracking-[0.04em]">
              Beneficios
            </p>
            <ul className="list-none p-0 m-0 mb-40">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-12 text-18 text-[#1b1b1b] py-10 border-b border-[#f0f0f0] last:border-b-0">
                  <CheckCircleIcon className="!text-20 text-[#1A56DB] shrink-0" />
                  {b}
                </li>
              ))}
            </ul>

            <CtaButton to="/contact">Agenda una demostración</CtaButton>
          </Grid>

          <Grid size={{ xs: 12, md: 5 }}>
            <div className="bg-[linear-gradient(135deg,#1E3A8A_0%,#1A56DB_100%)] rounded-20 h-full min-h-[420px] flex flex-col items-center justify-center py-48 px-32 text-center gap-20">
              <FactoryIcon className="!text-60 text-white/20" />
              <p className="text-white text-18 leading-[1.6] opacity-85">
                Gestión REP centralizada, confiable y lista para reportar ante autoridades regulatorias.
              </p>
            </div>
          </Grid>

        </Grid>
      </div>
    </section>
  );
}

export default ProducersSection;
